import { useQuery } from "@tanstack/react-query";
import categoryApi from "../../../services/categoryApi";

type UseCategoriesQuery = {
  enabled?: boolean;
};

export const useCategoriesQuery = (opt: UseCategoriesQuery) => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: categoryApi.getCategories,
    staleTime: 1000 * 60, // 1 minute
    enabled: opt.enabled ?? false,
  });
};
